import { render } from "./HeroiconsOutlineCheck.vue?vue&type=template&id=13d802c6"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCheck.vue"]])

export default __exports__